import { APP_SITE_ORIGIN } from "../constants/siteDomains";

export function therapistReviewPath(therapistId: string): string {
  return `/avaliar/${encodeURIComponent(therapistId)}`;
}

export function therapistReviewUrl(therapistId: string): string {
  return `${APP_SITE_ORIGIN}${therapistReviewPath(therapistId)}`;
}
